import{m as t}from"./chunk-HBP5N4FR.js";t();import{useEffect as f,useRef as o}from"react";var T=e=>{let r=o(e);return f(()=>{r.current=e},[e]),r};export{T as a};
//# sourceMappingURL=chunk-B67T4Z5G.js.map
